


















import filesize from "filesize";
import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { isAudioFile } from "@/lib/fileHelpers";
import { getMediaDuration } from "@/lib/time";
import { PostFileData } from "@/types";
import BaseIcon from "@/components/BaseIcon";
import { LoadingListItem } from "@/components/ContentLoadingPlaceholders";
import PreviewSetButton from "../../../PreviewSetButton";

@Component({ name: "PreviewListItem", components: { LoadingListItem, PreviewSetButton, BaseIcon } })
export default class PreviewListItem extends Vue {
  @Prop({ required: true })
  public readonly postFile!: PostFileData;

  @Prop({ type: Boolean, default: false })
  public readonly public!: boolean;

  public get icon() {
    if (isAudioFile(this.postFile)) return "sci-music-box";
    return "sci-file";
  }

  public get description() {
    if (isAudioFile(this.postFile) && this.postFile.duration) {
      return getMediaDuration(this.postFile.duration);
    }
    return filesize(this.postFile.size);
  }

  public isNotActive(loaded: boolean, loading: boolean) {
    if (!loaded) {
      return !loading;
    } else {
      return !this.public;
    }
  }

  public onClick(loaded: boolean) {
    if (loaded) this.$emit("publicChange", this.postFile.id);
  }
}
